export default __webpack_public_path__ + "static/media/nurve.ec2815f8.png";